import React, { useId } from 'react';

export interface LoadingCircleProps {
	className?: string;
}

export const LoadingCircle: React.FC<LoadingCircleProps> = ({ className }) => {
	const id = useId();
	const gradientId = `loading-gradient-${id}`;
	const arcId = `loading-arc-${id}`;
	const circle1Id = `loading-circle1-${id}`;
	const circle2Id = `loading-circle2-${id}`;
	const circle3Id = `loading-circle3-${id}`;

	return (
		<svg
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			width="100%"
			height="100%"
			viewBox="-64 -64 128 128">
			<defs>
				<linearGradient id={gradientId} x1="0" x2="0.90" y1="0" y2="1">
					<stop offset=".5" stopColor="#0050b3" stopOpacity="0"/>
					<stop offset="0.99" stopColor="#0050b3" stopOpacity="1"/>
					<stop offset="1" stopColor="#0050b3"/>
				</linearGradient>
			</defs>
			<path
				id={arcId}
				d="M0 -50 A50 50 0 0 1 50 0 L0 0 z"
				style={{ stroke: 'none', fill: `url(#${gradientId})` }}
				opacity=".5">
				<animateTransform
					attributeType="xml"
					attributeName="transform"
					type="rotate"
					from="40 0 0"
					to="400 0 0"
					dur="3"
					repeatCount="indefinite"/>
			</path>
			<circle
				id={circle1Id}
				cx="0"
				cy="0"
				r="50"
				opacity="0"
				style={{ stroke: '#0050b3', strokeWidth: 4, fill: 'none' }}>
				<animate
					attributeName="opacity"
					values="1;0"
					begin="0s"
					dur="6s"
					repeatCount="indefinite"/>
				<animateTransform
					attributeName="transform"
					calcMode="spline"
					keySplines="0.05 0 0.05 1"
					type="scale"
					values="0;1"
					begin="0s"
					dur="6s"
					repeatCount="indefinite"/>
			</circle>
			<circle
				id={circle2Id}
				cx="0"
				cy="0"
				r="50"
				opacity="0"
				style={{ stroke: '#0050b3', strokeWidth: 4, fill: 'none' }}>
				<animate
					attributeName="opacity"
					values="1;0"
					begin="2s"
					dur="6s"
					repeatCount="indefinite"/>
				<animateTransform
					attributeName="transform"
					calcMode="spline"
					keySplines="0.05 0 0.05 1"
					type="scale"
					values="0;1"
					begin="2s"
					dur="6s"
					repeatCount="indefinite"/>
			</circle>
			<circle
				id={circle3Id}
				cx="0"
				cy="0"
				r="50"
				opacity="0"
				style={{ stroke: '#0050b3', strokeWidth: 4, fill: 'none' }}>
				<animate
					attributeName="opacity"
					values="1;0"
					begin="4s"
					dur="6s"
					repeatCount="indefinite"/>
				<animateTransform
					attributeName="transform"
					calcMode="spline"
					keySplines="0.05 0 0.05 1"
					type="scale"
					values="0;1"
					begin="4s"
					dur="6s"
					repeatCount="indefinite"/>
			</circle>
		</svg>
	);
}; 
